import { useQuery } from '@tanstack/react-query';
import type { Machine } from '@bridgewerk/shared';
import { getApiClient } from '../../../lib/api-client.js';
import { machineKeys } from '../../../lib/query-keys.js';

export interface MachineDetailQuery {
  readonly machine: Machine | undefined;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly refetch: () => void;
}

export function useMachineDetail(
  shopId: string | null,
  machineId: string | null,
): MachineDetailQuery {
  const enabled = !!shopId && !!machineId;
  const query = useQuery({
    queryKey: enabled ? machineKeys.detail(shopId!, machineId!) : ['machines', 'none'],
    queryFn: () => getApiClient().getMachine(shopId!, machineId!),
    enabled,
  });
  return {
    machine: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
}
